class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    if (this.hasAttribute('data-open-on-hover')) this.setupHover();
  }

  /* Desktop mouse only: open on hover, close shortly after the pointer leaves. Click/tap/keyboard still work. */
  setupHover() {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const summary = this.mainDetailsToggle.querySelector('summary');

    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !canHover.matches) return;
      clearTimeout(this.hoverCloseTimer);
      document.querySelectorAll('header-menu details[open]').forEach((details) => {
        if (details !== this.mainDetailsToggle) {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', false);
        }
      });
      if (!this.mainDetailsToggle.open) {
        this.mainDetailsToggle.setAttribute('open', '');
        summary.setAttribute('aria-expanded', true);
        this.openedByHover = true;
      }
    });

    this.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse' || !canHover.matches) return;
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = setTimeout(() => {
        this.openedByHover = false;
        this.close();
      }, 200);
    });

    /* A click right after hover-opening keeps the menu open instead of toggling it shut. */
    summary.addEventListener('click', (event) => {
      if (this.openedByHover && this.mainDetailsToggle.open) {
        event.preventDefault();
        this.openedByHover = false;
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
